module.exports = __webpack_public_path__ + "static/img/domainLogo.d61a02f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avb-complete/domainLogo.png
// module id = iHh7
// module chunks = 1